(() => {
  class HeBadania extends HTMLElement {
    constructor() {
      super();
      this.splide = null;
      this._docClick = null;
      this._onScroll = null;
      this._scrollList = null;
    }

    connectedCallback() {
      this.initTooltips();
      this.initMobileSlider();
    }

    initTooltips() {
      this.querySelectorAll('.he-badania__cert-tooltip-wrap').forEach((wrap) => {
        const btn = wrap.querySelector('.he-badania__cert-info-btn');
        const tooltip = wrap.querySelector('.he-badania__cert-tooltip');
        if (!btn || !tooltip) return;

        // Move tooltip to <he-badania> root — escapes Splide's transform:translate3d
        // which breaks position:fixed for elements inside .splide__list
        this.appendChild(tooltip);

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const isShown = tooltip.classList.contains('is-shown');

          this._closeTooltips();

          if (!isShown) {
            const rect = btn.getBoundingClientRect();
            const isMobile = window.innerWidth < 992;
            tooltip.style.top = (rect.bottom + 8) + 'px';
            tooltip.style.left = isMobile
              ? window.innerWidth / 2 + 'px'
              : (rect.left + rect.width / 2) + 'px';
            tooltip.classList.add('is-shown');
          }
        });
      });

      this._docClick = () => this._closeTooltips();
      document.addEventListener('click', this._docClick);

      this._onScroll = () => this._closeTooltips();
      window.addEventListener('scroll', this._onScroll, { passive: true });

      this._scrollList = this.querySelector('.he-badania__certs-list--scroll');
      if (this._scrollList) {
        this._scrollList.addEventListener('scroll', this._onScroll, { passive: true });
      }
    }

    _closeTooltips() {
      this.querySelectorAll('.he-badania__cert-tooltip.is-shown').forEach((t) =>
        t.classList.remove('is-shown')
      );
    }

    initMobileSlider() {
      const el = this.querySelector('.he-badania__certs-mobile');
      if (!el || typeof Splide === 'undefined') return;

      if (el.querySelectorAll('.splide__slide').length <= 1) {
        el.classList.add('is-rendered', 'he-badania__certs-mobile--single');
        const progress = this.querySelector('.he-badania__progress');
        if (progress) progress.style.display = 'none';
        return;
      }

      const bar = this.querySelector('.he-badania__progress-bar');

      this.splide = new Splide(el, {
        type: 'slide',
        perPage: 1,
        gap: '20px',
        padding: { left: '16px', right: '40px' },
        pagination: false,
        arrows: false,
        drag: true,
        snap: true,
        speed: 400,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        mediaQuery: 'min',
        breakpoints: {
          992: { destroy: true },
        },
      });

      if (bar) {
        this.splide.on('mounted move', () => {
          const total = this.splide.length;
          const progress = total > 1 ? Math.min((this.splide.index + 1) / total, 1) : 1;
          bar.style.width = progress * 100 + '%';
        });
      }

      this.splide.on('move', () => this._closeTooltips());

      this.splide.mount();
    }

    disconnectedCallback() {
      if (this.splide) {
        this.splide.destroy();
        this.splide = null;
      }
      if (this._docClick) {
        document.removeEventListener('click', this._docClick);
        this._docClick = null;
      }
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
        if (this._scrollList) {
          this._scrollList.removeEventListener('scroll', this._onScroll);
          this._scrollList = null;
        }
        this._onScroll = null;
      }
    }
  }

  if (!customElements.get('he-badania')) {
    customElements.define('he-badania', HeBadania);
  }
})();
